module.exports = __webpack_public_path__ + "fc86eee4d343e63e0a085ff15628500b.png";